import FilterView from './filter-view'

export default FilterView
